import React, { useState } from 'react';

const FooterProductsSection = () => {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  const sections = [
    {
      id: 'collision',
      title: 'Advanced Train Collision Avoidance Systems',
      links: [
        { label: 'EULYNX Protocol Box', href: '#' },
        { label: 'Design Document Automation', href: '#' },
      ],
    },
    {
      id: 'smart-yard',
      title: 'Smart Yard Solutions',
      links: [
        { label: 'Safety Management', href: '#' },
        { label: 'Asset Management', href: '#' },
      ],
    },
    {
      id: 'om',
      title: 'Operations & Maintenance',
      links: [
        { label: 'Metro Corridors', href: '#' },
      ],
    },
  ];

  return (
    <div className="col-12 col-md-4 mb-4">
      <h6 className="fs-20">Products & Solutions</h6>
      <ul className="list-unstyled">
        {sections.map((section) => (
          <li key={section.id} className="mb-2">
            <div
              className="text-white text-decoration-none d-flex align-items-center gap-2 mt-3"
              onClick={() => toggleSection(section.id)}
              style={{ cursor: 'pointer' }}
            >
              <span style={{ fontSize: "16px" }}>
                {openSection === section.id ? '▼' : '▶'}
              </span>
              {section.title}
            </div>
            {openSection === section.id && (
              <ul className="list-unstyled ps-4 mt-2">
                {section.links.map((link, i) => (
                  <li key={i} className="mb-1">
                    {/* <a
                      href={link.href}
                      className="text-white text-decoration-none hover-underline2"
                    >
                      {link.label}
                    </a> */}
                    <label className='text-white'>{link.label}</label>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FooterProductsSection;
